import PropTypes from 'prop-types';
// @mui
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Autocomplete, Card } from '@mui/material';
import TextField from '@mui/material/TextField';
import { useCallback } from 'react';

// ----------------------------------------------------------------------

export default function AppSelectDevice({
  devices,
  setSelectedDevices,
  updateShipmentList,
  // setNeedUpdate
  triggerRefresh,
}) {
  const handleDevicesChange = useCallback((event, data) => {
    updateShipmentList(false,[])
    // setNeedUpdate(true)
    triggerRefresh?.()
    setSelectedDevices(data.map(({value: { id }}) => id))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setSelectedDevices, updateShipmentList, triggerRefresh])
  return (
    <Card
      spacing={2}
      alignItems={{ xs: 'flex-end', md: 'center' }}
      direction={{
        xs: 'column',
        md: 'row',
      }}
      sx={{
        p: 2.5,
        pr: { xs: 2.5, md: 1 },
        py: 5,
        boxShadow: '0 0 5px rgba(0, 0, 0, 0.01), 0 5px 5px rgba(0, 0, 0, 0.02)',
        borderRadius: 2,
      }}
    >
      <Stack
        spacing={1}
        sx={{
          width: "95%",
        }}
      >
        <Typography variant="h6" sx={{ mb: 1 }}>
          Selecione o dispositivo
        </Typography>
        <Autocomplete
          multiple
          id="combo-box-demo"
          options={devices.map((item) => ({ label: item.nickname ? `${item.name} - ${item.nickname}` : item.name, value: item}))}
          onChange={(event, data) => {
            handleDevicesChange(event, data);
          }}
          sx={{
            width: "100%",
            backgroundColor: "background.neutral",
          }}
          renderInput={(params) => <TextField
            {...params}
            label="Dispositivos"
          />}
        />
      </Stack>
    </Card>
  );
}

AppSelectDevice.propTypes = {
  devices: PropTypes.array,
  setSelectedDevices: PropTypes.func,
  updateShipmentList: PropTypes.func,
  // setNeedUpdate: PropTypes.func
  triggerRefresh: PropTypes.func
};
